"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NotNullInput = function NotNullInput(_ref) {
  var filter = _ref.filter,
      _onChange = _ref.onChange;
  return _react["default"].createElement(_style.StyledCheckbox, null, _react["default"].createElement("input", {
    type: "checkbox",
    id: "filter-no-null-".concat(filter.id),
    checked: filter.notNull,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    }
  }), _react["default"].createElement("label", {
    htmlFor: "filter-no-null-".concat(filter.id)
  }, "Remove \"null\" values"));
};

var _default = NotNullInput;
exports["default"] = _default;